import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

import CloseRoundIcon from "theme/icons/CloseRound";

import useTheme from "hooks/useTheme";

const PasteFromClipBoardModal = ({ isOpen, setIsOpen, PasteFromClipboard, inputValue, setInputValue, submit }) => {
	const { appLanguage, themeColor } = useTheme();

	return (
		<Transition appear show={isOpen} as={Fragment}>
			<Dialog as="div" className="relative z-10" onClose={() => setIsOpen(false)}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className={`fixed inset-0 ${themeColor?.bg} bg-opacity-30`} />
				</Transition.Child>

				<div className="fixed inset-0 overflow-y-auto">
					<div className="flex min-h-full items-center justify-center p-4 text-center">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
						>
							<Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-2xl space-y-5 bg-white p-6 text-left align-middle shadow-xl transition-all">
								<div className="flex flex-col w-full items-center space-y-5">
									<div className="flex w-full items-center justify-between">
										<p className={`text-md ${themeColor?.text}`}>{appLanguage?.enterYourSecretWords}</p>
										<CloseRoundIcon
											className="w-4 cursor-pointer"
											fill={themeColor?.hex}
											onClick={() => setIsOpen(false)}
										/>
									</div>

									<textarea
										className={`flex flex-col w-full h-44 row-span-full rounded-lg p-3 text-sm border ${themeColor?.border}  focus:outline-none focus:${themeColor?.ring} `}
										value={inputValue ? inputValue.join(" ") : ""}
									/>
								</div>

								<div className="w-full flex space-x-3 justify-center">
									<button
										className={`flex items-center px-4 py-2 rounded-lg text-white ${themeColor?.bg} space-x-3 hover:shadow-lg`}
										onClick={() => PasteFromClipboard()}
									>
										{appLanguage?.paste}
									</button>
									<button
										className={`flex items-center px-4 py-2 rounded-lg text-white ${themeColor?.bg} space-x-3 hover:shadow-lg`}
										onClick={() => setInputValue(null)}
									>
										{appLanguage?.clear}
									</button>
									<button
										className={`flex items-center px-4 py-2 rounded-lg text-white ${themeColor?.bg} space-x-3 hover:shadow-lg`}
										onClick={() => submit()}
									>
										{appLanguage?.ok}
									</button>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition>
	);
};

export default PasteFromClipBoardModal;
